const d =
	'M369-95H180q-34.025 0-59.512-25.488Q95-145.975 95-181v-189q35-5 59.5-31.5T179-464q0-36-24.5-62.5T95-557v-190q0-34.025 25.488-59.513Q145.975-832 180-832h155q19-45 52.5-72t76.5-27q43 0 77.5 27t53.5 72h152q34.025 0 59.513 25.487Q832-781.025 832-747v152q45 19 71 55t26 79q0 43-26 75.5T832-334v154q0 34.025-25.487 59.512Q781.025-95 747-95H558q-6-43-32.75-69T463-190q-34.5 0-61.75 26.125T369-95Z';

export default d;
